// extracted by mini-css-extract-plugin
module.exports = {"SizeBar":"SizeBar_SizeBar__2b29Z","progress-bar":"SizeBar_progress-bar___zjk_"};